import React from 'react'
import useOperation from './use-operation'
import { useObservableBoxValue } from '@morningtrain/react-helpers'

export default function useOperationLoadedState () {
  const operation = useOperation()

  if (!operation) {
    throw new Error('Trying to use operation loaded state, but operation is not provided')
  }

  if (!operation.loaded) {
    throw new Error('Trying to use operation loaded state, but operation.loaded is not provided - are you using an updated package version?')
  }

  return useObservableBoxValue(operation.loaded)
}
